var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { getStringCellValue } from './string-cell-renderer.utils';
import { _ as Utils } from '@ag-grid-community/core';
import animateCellChange from '../animate-cell-change/animate-cell-change.decorator';
import isEqual from 'lodash/isEqual';
const TEMPLATE = '<span class="ag-value-change-value"></span>';
export class StringCellRendererComponent {
    constructor() {
        this.eGui = document.createElement('span');
        this.eGui.innerHTML = TEMPLATE;
        this.lastValue = undefined;
    }
    init(params) {
        this.eValue = this.getGui().querySelector('.ag-value-change-value');
        this.refresh(params);
    }
    getGui() {
        return this.eGui;
    }
    refresh(params) {
        const value = getStringCellValue(params.value);
        if (isEqual(value, this.lastValue)) {
            return false;
        }
        if (Utils.exists(params.valueFormatted)) {
            this.eValue.innerHTML = params.valueFormatted;
        }
        else if (Utils.exists(params.value)) {
            this.eValue.innerHTML = value;
        }
        else {
            Utils.clearElement(this.eValue);
        }
        this.lastValue = value;
        return true;
    }
}
__decorate([
    animateCellChange({
        timer: 2000,
        highlight: true,
        delta: false,
    })
], StringCellRendererComponent.prototype, "refresh", null);
